export default "__VITE_ASSET__BpQVhTSz__"